"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$ = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$outboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$inboundSchema = void 0;
exports.fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapperToJSON = fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapperToJSON;
exports.fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapperFromJSON = fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapperFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const timeonmarket_js_1 = require("./timeonmarket.js");
const timeonmarketbypropertytype_js_1 = require("./timeonmarketbypropertytype.js");
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$inboundSchema = z.object({
    locality: timeonmarket_js_1.TimeOnMarket$inboundSchema,
    property_type: z.array(timeonmarketbypropertytype_js_1.TimeOnMarketByPropertyType$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "property_type": "propertyType",
    });
});
/** @internal */
exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$outboundSchema = z.object({
    locality: timeonmarket_js_1.TimeOnMarket$outboundSchema,
    propertyType: z.array(timeonmarketbypropertytype_js_1.TimeOnMarketByPropertyType$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        propertyType: "property_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$;
(function (FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$) {
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$inboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$.inboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$inboundSchema;
    /** @deprecated use `FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$outboundSchema` instead. */
    FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$.outboundSchema = exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$outboundSchema;
})(FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$ || (exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$ = FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$ = {}));
function fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapperToJSON(fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper) {
    return JSON.stringify(exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$outboundSchema
        .parse(fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper));
}
function fastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapperFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'FastapiKrakenEndpointsStatsModelsSalesLocalAuthorityGetAverageTimeOnMarketResponsesTimeOnMarketWrapper' from JSON`);
}
//# sourceMappingURL=fastapikrakenendpointsstatsmodelssaleslocalauthoritygetaveragetimeonmarketresponsestimeonmarketwrapper.js.map